import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg18InviteG = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("path", {
        d: "M14.6 4c.773 0 1.4.616 1.4 1.375v8.25c0 .76-.627 1.375-1.4 1.375H3.4c-.773 0-1.4-.616-1.4-1.375v-8.25C2 4.615 2.627 4 3.4 4zm0 1.031H3.4a.35.35 0 0 0-.344.282l-.006.062v8.25c0 .169.124.31.287.338l.063.006h11.2a.35.35 0 0 0 .344-.282l.006-.062v-8.25a.345.345 0 0 0-.287-.338z"
      }), /*#__PURE__*/jsx("path", {
        d: "M3.798 6.189a.53.53 0 0 1 .668-.152l.066.04L8.995 9.29 13.4 6.08a.53.53 0 0 1 .684.048l.05.058a.506.506 0 0 1-.05.671l-.058.05-4.716 3.438a.53.53 0 0 1-.559.041l-.064-.04L3.91 6.91a.51.51 0 0 1-.113-.72z"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18InviteG$1 = Svg18InviteG;

export { Svg18InviteG$1 as default };
